/* eslint-disable @typescript-eslint/camelcase */ /* eslint-disable import/no-named-as-default */ import { UserManager } from "oidc-client";
import { redirectUri, silentRedirectUri } from "../../config/routes";
import getSettings from "./getSettings";
var storedUserManager = null;
/**
 * Store the user manager and return it
 * @param {UserManager} userManager
 * @returns {UserManager}
 */ var storeUserManagerAndReturn = function(userManager) {
    storedUserManager = userManager;
    return userManager;
};
/**
 * Get the userManager
 * @returns {Promise<UserManager>}
 */ export var getUserManager = function() {
    if (storedUserManager) {
        return Promise.resolve(storedUserManager);
    }
    return getSettings().then(function(settings) {
        return storeUserManagerAndReturn(new UserManager({
            authority: settings.oidc_authority,
            client_id: settings.oidc_client_id,
            redirect_uri: redirectUri,
            silent_redirect_uri: silentRedirectUri
        }));
    });
};
// Export userManager
export default getUserManager;

//# sourceMappingURL=userManager.js.map